import { useState } from "react";
import error from "../../assets/images/error.svg";
import { FC, ReactNode } from "react";
import unchecked from "../../assets/images/unchecked.png";
import checked from "../../assets/images/checked.png";
import React from "react";

interface ICheckBox {
    name?: string,
    label: ReactNode,
    errFl?: Boolean;
    errorMsg?: string;
    [k: string]: any
}

const id = Date.now()
const CheckBox: FC<ICheckBox> = ({
    name,
    label,
    errFl,
    errorMsg,
    ...rest
}) => {
    const [Checked, setChecked] = useState(false)
    const handleChangeChecked = (e:any) => {
        setChecked(e.target.checked)
    }
    return (
        <>
            <label {...rest} htmlFor={`${id}`} className="c-checkbox">
                <input onChange={handleChangeChecked} id={`${id}`} type="checkbox" name={name} />
                {/* <div className={`fake-checkbox ${Checked ? 'checked' : ''}`}></div> */}
                

                {!Checked? <div><img src={unchecked} alt="checked" /></div>:
                                <div className="checked">
                                <img src={checked} alt="checked" />
                            </div>
                }
                <div className="label">{label}</div>
            </label>
            {errFl? (
            <div
                className={`${!errFl? "hidden" : "row-input1"}`}
            >
                <div className="label">
                <img src={error} alt="" />
                </div>
                <div className="error">{errorMsg}</div>
            </div>
            ) : null}
        </>
    )
}

export default CheckBox